import ThreeHorseLoading from "react-loadingg/lib/ThreeHorseLoading";
import React from "react";

const commonStyle = {
    margin: 'auto',
    position: 'initial',
    left: 0,
    right: 0,
    top:10,
    bottom:10
};

function ValidateAppointment({texto}){

    return  (
        <div className="react-loader-overlay">
            <div className="react-confirm-alert">
                <div className="custom-ui">
                        <h2>{texto ? texto : 'cargando...'}</h2>
                        <ThreeHorseLoading color={"#6586FF"} style={commonStyle}/>
                </div>
            </div>
        </div>
    )
}

export default ValidateAppointment